// src/pages/Reports/CurrentAssetLedger/currentAssetLedgerThunk.js
import { createAsyncThunk } from "@reduxjs/toolkit";
import { postData } from "../../../apiservice/apis";
import { getCurrentAssetLedgerApi } from "../../../apiservice/reports";

export const fetchCurrentAssetLedger = createAsyncThunk(
  "currentAssetLedger/fetch",
  async ({ accId, fromDate, toDate }, { rejectWithValue }) => {
    try {
      const res = await getCurrentAssetLedgerApi({
        accId,
        dateFrom: fromDate,
        dateTo: toDate,
      });

      const { opening_balance, ledger, closing_balance } = res.data;

      const mapped = ledger.map((row, index) => ({
        id: `${row.vch_no}-${index}`,
        date: row.created_date,
        particular: row.particular,
        vch_no: row.vch_no,
        vch_type: row.vch_type,
        debit: Number(row.debit_amount || 0),
        credit: Number(row.credit_amount || 0),
        balance: Number(row.balance || 0),
      }));

      return {
        list: mapped,
        opening_balance: Number(opening_balance || 0),
        closing_balance: Number(closing_balance || 0),
      };
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);
